export default function Footer(props) {
  return (
    <footer
      style={{
        height: "42px",
        bottom: "1px",
        left: "0px",
        right: "0px",
        backgroundColor: "rgba(242, 242, 242, 1)"
      }}
      className="inherit-parent-width position-absolute display-flex flex-justify-content-center flex-align-items-center"
    >
      <div
        data-cy={props.description}
        className="font-size-smaller text-align-center"
      >
        {props.description}
      </div>
    </footer>
  );
}
